;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.2";import * as Sentry from '@sentry/nextjs';
import { getEnv } from '@/lib/env';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: getEnv('NEXT_PUBLIC_SENTRY_DSN'),
    environment: getEnv('NEXT_PUBLIC_RAILS_ENV') || 'production',
    beforeSend(event) {
      if (
        event.exception &&
        (event.exception.values[0].value.includes('Request failed') ||
          event.exception.values[0].value.includes('AbortError'))
      ) {
        return null;
      }
      return event;
    },
    replaysOnErrorSampleRate: 0,
    replaysSessionSampleRate: 0,
    tracesSampleRate: 0,
    debug: false
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
